export default function Card({ title, tag, children, style }) {
  return (
    <section className="card" style={style}>
      {(title || tag) && (
        <div className="card-head">
          <div className="card-title">{title}</div>
          {tag && <div className="card-tag">{tag}</div>}
        </div>
      )}
      {children}
    </section>
  );
}
